import { render, staticRenderFns } from "./BlockType13Grid.vue?vue&type=template&id=76c30e5d&scoped=true"
import script from "./BlockType13Grid.vue?vue&type=script&lang=ts"
export * from "./BlockType13Grid.vue?vue&type=script&lang=ts"
import style0 from "./BlockType13Grid.vue?vue&type=style&index=0&id=76c30e5d&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../src-custom-solutions/president-election/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "76c30e5d",
  null
  
)

export default component.exports